/** P0 (07/10/2026): "hoy" de negocio = hoy en Europe/Madrid, NUNCA la zona del dispositivo.
 * Antes `todayISO()` usaba `new Date()` local -- un dispositivo en otra zona pedía al backend
 * el día equivocado (Hoy/Mañana de JA Lab, que el backend resuelve en Europe/Madrid). Usa
 * `Intl` con IANA real (DST correcto), nunca un offset manual. */
export const MADRID_TIMEZONE = 'Europe/Madrid'

export function madridISODate(d: Date): string {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: MADRID_TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(d)
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? ''
  return `${get('year')}-${get('month')}-${get('day')}`
}

export function todayISO(): string {
  return madridISODate(new Date())
}

export function toISODate(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function addDays(iso: string, delta: number): string {
  const d = new Date(`${iso}T12:00:00`)
  d.setDate(d.getDate() + delta)
  return toISODate(d)
}

export function formatDateLabel(iso: string): string {
  if (iso === todayISO()) return 'Hoy'
  if (iso === addDays(todayISO(), -1)) return 'Ayer'
  return new Date(`${iso}T12:00:00`).toLocaleDateString('es-ES', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })
}
